import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="page"
export default class extends Controller {
  static values = {
    active: Boolean,
    visible: Boolean,
    kind: String,
    url: String,
    id: Number,
    schemes: Array,
    deletion: Boolean,
    md5: String,
    urls: Object,
    duration: Number,
  };

  connect() {
    this.element.controller = this;

    console.log('SCHEME', this.scheme())

    this.element.addEventListener("transitionend", (event) => {
      if (event.propertyName != 'opacity') return;
      this.element.classList.remove("page--hide");
      this.element.classList.remove("page--visible");

      console.log('CLASSES', this.element.classList)
    });

    switch (this.kindValue) {
      case "custom":


        const canvas = this.element.querySelector('[data-canvas-background]')

        if (canvas) {
          this.element.style.backgroundColor = canvas.dataset.canvasBackground;
          return
        }
      case "image":
        let img = document.createElement("img");
        img.src = this.urlValue;
        img.dataset.action = "load->page#imageLoaded";
        this.element.appendChild(img);
        break;
      case "youtube":
        let el = document.createElement('lite-youtube')
        el.setAttribute('videoid', this.urlValue)
        el.setAttribute('js-api', '1')
        el.setAttribute('params', 'enablejsapi=1&mute=1&rel=0&controls=0&wmode=transparent&iv_load_policy=3&vq=hd720')
        el.id = `youtube-${this.idValue}`;
        el.allow = "autoplay";
        el.style.visibility = 'hidden'
        this.element.appendChild(el)

        // let iframe = document.createElement("iframe");
        // iframe.src = this.urlValue;
        // iframe.type = "text/html";
        // iframe.id = `youtube-${this.idValue}`;
        // iframe.allow = "autoplay";
        // iframe.allowFullscreen = true;
        // //iframe.width = window.innerWidth;
        // //iframe.height = window.innerHeight;
        // this.element.appendChild(iframe);

        break;
    }
  }

  onPlayerReady(event) {
    this.player.then((p) => p.playVideo());
  }

  onPlayerStateChange(event) {
    //document.querySelector('#debug').innerHTML = event.data

    this.element.querySelector("lite-youtube").style.visibility = (event.data == YT.PlayerState.PLAYING) ? 'visible' : 'hidden';


    switch (event.data) {
      case YT.PlayerState.ENDED:


        let e = new CustomEvent("pages-next");
        window.dispatchEvent(e);

        this.playing = false;
        break;
      case YT.PlayerState.UNSTARTED:
        break;
      case YT.PlayerState.PLAYING:
        break;
      case YT.PlayerState.PAUSED:
        break;
      case YT.PlayerState.BUFFERING:
        break;
      case YT.PlayerState.CUED:
        if (this.playing) return;

        this.playing = true;

        this.player.then((p) => p.playVideo());
        break;
    }
  }

  update(result) {
    //if (result.md5 == this.md5Value) return;

    this.replaceBy = result;

    if (document.querySelector(".page").length == 1) {
      this.replace();
    }
  }

  replace() {
    this.element.outerHTML = this.replaceBy.html;

    this.replaceBy = null;
  }

  show() {
    this.visibleValue = true;
    setTimeout(() => fetch(this.urlsValue.event));
  }

  hide() {
    this.visibleValue = false;
  }

  deletionValueChanged() {
    if (
      this.deletionValue &&
      document.querySelectorAll(".page[data-page-deletion-value]").length ==
      document.querySelectorAll(".page").length
    ) {
      this.element.remove();
    }
  }

  visibleValueChanged(newValue, oldValue) {
    if (this.replaceBy && !this.visibleValue) {
      this.replace();
    }

    if (this.visibleValue) {
      this.element.classList.add("page--visible");

      switch (this.kindValue) {
        case "youtube":
          if (this.player) {
            this.player.then((p) => p.playVideo());

            return;
          }

          this.player = this.element.querySelector("lite-youtube").getYTPlayer();

          this.player.then((p) => {
            p.addEventListener('onStateChange', this.onPlayerStateChange.bind(this));
            p.addEventListener('onReady', this.onPlayerReady.bind(this));
          });

        // this.player = new YT.Player(`youtube-${this.idValue}`, {
        //   playerVars: {
        //     autoplay: 1,
        //     mute: 1,
        //     playsinline: 1,
        //     controls: 0,
        //     rel: 0,
        //   },
        //   events: {
        //     onReady: this.onPlayerReady.bind(this),
        //     onStateChange: this.onPlayerStateChange.bind(this),
        //   },
        // });
      }
    } else {
      if (this.deletionValue) {
        this.element.remove();
      } else {
        if (oldValue === undefined) {
          this.element.classList.remove("page--visible");
        } else {
          this.element.classList.add("page--hide");
        }
      }
    }
  }

  dateTime() {
    let date = new Date();

    return {
      date: date.toDateString(),
      hour: date.getHours(),
      minute: date.getMinutes(),
      day: date.getDay(),
    };
  }

  scheme() {
    if (this.schemesValue.length == 0) return true;

    let dateTime = this.dateTime();

    let scheme = this.schemesValue.find((scheme) => {
      let result = true;

      if (scheme.dates) {
        // ... TODO
      }

      if (scheme.times) {
        let hourMinute = parseInt(
          [dateTime.hour, dateTime.minute]
            .map((str) => str.toString().padStart(2, "0"))
            .join("")
        );

        let found = scheme.times.find((time) => {
          return hourMinute >= time[0] && hourMinute <= time[1];
        });

        if (!found) result = false;
      }

      if (scheme.days) {
        // ...
        if (!scheme.days.includes(dateTime.day)) result = false;
      }

      return result;
    });

    return scheme;
  }

  imageLoaded() { }
}
